import { Location } from "history";

import { linkToRegionModal } from "common/links";

import { linkToSettings } from "features/parents/links";
import { linkToMorePage } from "features/parents/routes/parent/routes/mobile/more/links";
import { linkToParentFeedback } from "features/parents/routes/parent/routes/monitoring/routes/overview/routes/feedback/links";

export default function locationIncludesMoreRoute(location: Location) {
  return (
    location.pathname.includes(linkToMorePage()) ||
    location.pathname.includes(linkToSettings()) ||
    location.pathname.includes(linkToParentFeedback()) ||
    location.pathname.includes(linkToRegionModal())
  );
}
